<!--
@component
LiveBug

See markup below.
-->

<script lang="ts"></script>

<div class="live-container py-0.5 fpx-2" role="status" aria-label="Live">
  <span
    class="live-text uppercase font-bold tracking-wide text-xxs"
    aria-hidden="true">Live</span
  >
  <span class="beacon" aria-hidden="true"></span>
</div>

<style lang="scss">
  .live-container {
    background-color: var(--theme-colour-background);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    color: var(--theme-colour-live-red);
    outline: 1px solid var(--theme-colour-live-red);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    border-radius: 10rem;
  }

  .live-text {
    display: inline-block;
    line-height: 1;
  }

  .beacon {
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background-color: var(--theme-colour-live-red);
    transform-origin: center;
    animation: beacon 1s ease-out infinite alternate-reverse;
  }

  @keyframes beacon {
    from {
      transform: scale(0.9);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  // Respect users who prefer reduced motion
  @media (prefers-reduced-motion: reduce) {
    .beacon {
      animation: none;
      opacity: 1;
    }
  }
</style>
